module.exports = __webpack_public_path__ + "static/media/undraw_meet_the_team_e5b7.9b0c8b24.svg";